<div class="upload-file-container" appDragDrop (onFileDropped)="uploadFile($event)">
  <input hidden type="file" #fileInput (change)="uploadFile($event.target.files)"
         [multiple]="multiple">

  <div class="upload-file" (click)="openFile()" [class.handle-click]="canHandleClick" *ngIf="!uploadCompleted">
    <h4 class="upload-title">{{title}}</h4>
    <div class="upload-file-content">
      <img alt="file icon" class="fa-file" src="https://allya-lib-assets.s3-sa-east-1.amazonaws.com/ng-core/fileupload.svg">
      <div class="upload-file-info" *ngIf="!files.length">
        <span><a>Procure um arquivo</a> ou arraste e solte-o aqui.</span>
        <span class="upload-file-subtitle">{{subtitle}}</span>
      </div>

      <div class="upload-file-info" *ngIf="files.length">
        <div class="upload-file-list" *ngFor="let file of files; let i = index">
          <div class="upload-file-title">{{file.name}}
            <button class="btn-trash" (click)="deleteFile(i)"><i class="fa fa-trash"></i></button>
          </div>
          <span class="upload-file-subtitle">{{humanFileSize(file.size)}}</span>
          <span class="upload-file-warning" *ngIf="disabled">Aguarde todos arquivos serem processados, para fazer um novo upload.</span>
        </div>
      </div>

      <div class="upload-file-actions">
        <button *ngIf="sendInvite" class="btn btn-orange" (click)="sendFile(true)" [class.btn-disabled]="!files.length || disabled">Cadastrar e enviar convite</button>
        <button class="btn btn-orange" (click)="sendFile()" [class.btn-disabled]="!files.length || disabled">Cadastrar</button>
      </div>
    </div>

    <ng-core-loading *ngIf="loading"></ng-core-loading>
  </div>

  <div class="upload-file" *ngIf="uploadCompleted">
    <div class="upload-completed">
      <h4 class="upload-title">Upload finalizado</h4>

      <div class="upload-file-content">
        <img alt="file icon" class="fa-file" src="https://allya-lib-assets.s3-sa-east-1.amazonaws.com/ng-core/fileuploadok.svg">
        <div class="upload-file-info">
          <span>Iniciamos o cadastro dos colaboradores. Você pode fechar a página e voltar depois, ou acompanhar o status abaixo.</span>
          <span class="upload-file-subtitle">Caso existam registros incorretos, você poderá baixá-los e fazer as correções. Os registros corretos serão cadastrados normalmente.</span>
        </div>

        <div class="upload-file-actions">
          <button class="btn btn-orange" (click)="resetUpload()">Enviar outro arquivo</button>
        </div>
      </div>
    </div>
  </div>

  <div class="upload-file-error" *ngIf="error">
    <h2 class="error-title">{{error?.title}}</h2>
    <p [innerHTML]="error?.message">{{error?.message}}</p>
    <div class="container-button">
      <button class="btn" (click)="resetUpload()">Tentar novamente</button>
    </div>
  </div>
</div>
